module.exports = __webpack_public_path__ + "img/lot3.png";